import { Strophe } from 'react-strophe'
import * as xmpp from '../../global/xmppPayloadHelper'
import { extractError, send, validateConnected } from './serverConnection'
import { parseArchivedMessageReceived, parsePaginationDetails } from '../../global/messageParserHelper'
import { Chat } from '../../global/chatSettingsConfig'
import chatLog from '../../global/chat-log'
import orchestrationApi from '../orchestration'

/*
  Send a message to a person.
*/
export const postMessage = ({ toJid, fromJid, fromResource, message, fromDisplayName, connection }) => {
  chatLog('[Conversations] Sending message:', message)
  const stanza = xmpp.payloadToSendDirectMessage({ toJid, fromJid, fromResource, message, fromDisplayName })
  return send({ connection, stanza })
}

/**
 * Gets the archived messages between two people.
 * This will register a temporary handler to receive all the messages,
 * then delete the handler when finished.
 *
 * Returns an object that contains the first message id received
 * which the server treats as our pagination token.
 */
export const getChatHistory = ({ connection, toJid, fromJid, paginationToken, count }) => {
  const start = new Date()

  chatLog(`[Conversations] Getting the chat history: ${toJid} | ${fromJid}`)
  const messages = []
  const messageHandler = connection.addHandler((stanza) => {
    const data = parseArchivedMessageReceived({ stanza, isGroup: false })
    const isMe = data?.fromJid.toLowerCase() === fromJid.toLowerCase() || false
    const isForMe = data?.fromJid.toLowerCase() === toJid.toLowerCase() || false
    if (data?.message && (isMe || isForMe)) {
      messages.push(data)
    }

    return true
  }, Chat.NS.MAM_2)

  return new Promise((resolve, reject) => {
    const errorFn = (err) => {
      console.error(err)
      connection.deleteHandler(messageHandler)
      reject(extractError(err))
    }

    const successFn = (stanza1) => {
      const end = new Date()
      chatLog('[Conversations] Request finished.')
      connection.deleteHandler(messageHandler)

      const paginate = parsePaginationDetails(stanza1)
      const data = {
        paginationToken: paginate.isComplete ? undefined : paginate.first,
        messages: [...messages],
      }

      const duration = end.getTime() - start.getTime()
      // fire and forget
      try {
        const jabberResource = Strophe.getResourceFromJid(connection.jid)
        orchestrationApi.chatmetrics.logChatHistoryTiming({ jabberResource, jid: toJid, duration })
      } catch (e) {
        // ignoring
      }

      resolve(data)
    }

    const stanza = xmpp.payloadToGetChatHistory({ toJid, paginationToken, count })
    validateConnected({ connection, stanza })
    connection.sendIQ(stanza, successFn, errorFn, Chat.Settings.TIMEOUT)
  })
}
